<template>
  <SfDropdownMultiselect
    v-model="selectedUsers"
    data-testid="users-filter-dropdown"
    :options="options"
    dropdown-id="usersDropdownFilter"
    :placeholder="I18n.t('assistant_check.filters.users.search_placeholder')"
    :trigger-label="
      I18n.t('assistant_check.filters.users.trigger_labels.users')
    "
    :trigger-label-custom-suffix="I18n.t('assistant_check.filters.labels.any')"
  >
    <template #before>
      <SfDropdownItem
        class="tw-leading-3"
        :has-checkmark="pageStore.readByFilter.length === 0"
        :has-border="false"
        :class="{ 'tw-font-medium': pageStore.readByFilter.length === 0 }"
        @click="clearSelected"
      >
        {{ I18n.t('assistant_check.filters.labels.any') }}
      </SfDropdownItem>
    </template>
  </SfDropdownMultiselect>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import SfDropdownMultiselect from '@app/shared/vue/components/sf-dropdown/sf-dropdown-multiselect.vue'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useSfAssistantChecksPage } from '../stores/page'
import type { OptionGroup } from '@app/shared/vue/components/sf-dropdown/types'

const I18n = useI18n()
const pageStore = useSfAssistantChecksPage()

interface Props {
  options: OptionGroup[]
}

defineProps<Props>()

const selectedUsers = computed<string[]>({
  get: () => pageStore.readByFilter,
  set: (val: string[]) => {
    pageStore.readByFilter = val
  },
})

function clearSelected(): void {
  pageStore.readByFilter = []
}
</script>
